module.exports = __webpack_public_path__ + "img/lianmu.8026f276.png";